import styled from 'styled-components';
import { Box, device } from 'vqp-common';
import { Button } from '../../../components/common';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
  border-bottom: 1px solid ${(props) => props.theme.colors.lineGrey};
`;

export const Card = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
  width: 100%;
  box-sizing: border-box;
`;

export const Col1 = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 12px;
  margin: 16px 20px;
  width: calc(100% - 40px);
  box-sizing: border-box;
`;

export const FormLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const TopRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 140px;
  column-gap: 24px;
  align-items: start;
  width: 100%;

  @media ${device.mobile} {
    grid-template-columns: 1fr;
    row-gap: 14px;
  }
`;

export const MainRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 220px;
  column-gap: 24px;
  row-gap: 8px;
  align-items: stretch;
  width: 100%;

  @media ${device.mobile} {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto auto;
  }
`;

export const FieldHead = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;

  > div,
  > input,
  > textarea {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const CustomLabel = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.textPrimary};
  margin: 0 0 6px 0;
  min-height: 16px;
  line-height: 16px;
  display: block;
`;

export const Required = styled.span`
  color: #c62828;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid ${(props) => props.theme.colors.lineGrey};

  &.center {
    justify-content: center;
  }
`;

export const BackButton = styled(Button)``;

export const SaveButton = styled(Button)``;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PreviewWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 220px;
`;

export const ClearImageButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    background: rgba(0, 0, 0, 0.85);
  }
`;

export const PreviewImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  min-height: 220px;
  object-fit: contain;
  border: 1px solid ${(props) => props.theme.colors.lineGrey};
  border-radius: 5px;
  background: #f7f7f7;
  box-sizing: border-box;
`;

export const PreviewPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 220px;
  border: 1px solid ${(props) => props.theme.colors.lineGrey};
  border-radius: 5px;
  background: #fafafa;
  color: ${(props) => props.theme.colors.mediumGrey};
  font-size: 12px;
  text-align: center;
  padding: 12px;
  box-sizing: border-box;
`;

export const DescriptionBox = styled.div`
  width: 100%;
  height: 100%;
  min-height: 220px;

  > div {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  textarea {
    flex: 1;
    width: 100%;
    height: 100% !important;
    min-height: 220px !important;
    resize: none;
    box-sizing: border-box;
  }
`;

export const FileInput = styled.input`
  font-size: 13px;
  max-width: 100%;
`;

export const Hint = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.colors.mediumGrey};
  margin-top: 6px;
  line-height: 1.35;
  min-height: 15px;
`;
